var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTodaySharp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "today-sharp",
    transform: "translate(-2.25 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_528",
    "data-name": "Trazado 528",
    d: "M8.227,14.625h4.218a.352.352,0,0,1,.352.352v4.218a.352.352,0,0,1-.352.352H8.227a.352.352,0,0,1-.352-.352V14.977A.352.352,0,0,1,8.227,14.625Z",
    transform: "translate(-2.855 -6.282)",
    fill: "#0050c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_529",
    "data-name": "Trazado 529",
    d: "M17.107,3.393H15.393V2.25H13.964V3.393H6.536V2.25H5.107V3.393H3.393A1.143,1.143,0,0,0,2.25,4.536V17.107A1.143,1.143,0,0,0,3.393,18.25H17.107a1.143,1.143,0,0,0,1.143-1.143V4.536A1.143,1.143,0,0,0,17.107,3.393Zm-.429,13.286H3.822V7.393H16.679Z",
    transform: "translate(0)",
    fill: "#0050c4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodaySharp);
export default __webpack_public_path__ + "static/media/today-sharp.a26043b9b4e85635374757218a19870e.svg";
export { ForwardRef as ReactComponent };